var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRouteMapIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8382 12.5011C21.6134 12.7144 21.3129 12.8335 21.0001 12.8335C20.6873 12.8335 20.3868 12.7144 20.162 12.5011C18.1028 10.5371 15.3434 8.34312 16.6892 5.15782C17.4167 3.43555 19.1633 2.3335 21.0001 2.3335C22.8369 2.3335 24.5834 3.43555 25.3111 5.15782C26.6551 8.33911 23.9024 10.5439 21.8382 12.5011Z",
    stroke: "#161E21",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 7H21.0105",
    stroke: "#161E21",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83331 25.6665C7.76631 25.6665 9.33331 24.0995 9.33331 22.1665C9.33331 20.2335 7.76631 18.6665 5.83331 18.6665C3.90032 18.6665 2.33331 20.2335 2.33331 22.1665C2.33331 24.0995 3.90032 25.6665 5.83331 25.6665Z",
    stroke: "#161E21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 8.1665H11.0833C8.82817 8.1665 7 9.73351 7 11.6665C7 13.5996 8.82817 15.1665 11.0833 15.1665H14.5833C16.8385 15.1665 18.6667 16.7335 18.6667 18.6665C18.6667 20.5996 16.8385 22.1665 14.5833 22.1665H12.8333",
    stroke: "#161E21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouteMapIcon);
export default __webpack_public_path__ + "static/media/RouteMapIcon.ae3d48c144ab9b90e5abca9bece9ebef.svg";
export { ForwardRef as ReactComponent };